export const aboutData = {
  brandName: '欲望之岛',
  tagline: '探索内心，拥抱真实',
  foundingYear: '2024',
  introduction: [
    '欲望之岛诞生于一个简单的信念：每个人都有权利了解自己内心深处的渴望，并有能力将这些渴望转化为成长的动力。',
    '我们相信，欲望不是需要被压抑的"原罪"，而是人类最原始、最强大的生命力。当欲望被理解、被接纳、被引导时，它可以成为推动个人成长、改善人际关系、激发创造力的源泉。',
    '欲望之岛由一群心理学家、哲学家、艺术家和技术专家共同创立。我们的使命是创造一个安全、开放、有深度的空间，让每个人都能在这里探索自己的内心世界。',
    '我们拒绝简单的答案和快餐式的自我提升。我们提供的是深度的思考、真实的对话和经过验证的实践方法。',
  ],
  values: [
    {
      title: '真实',
      description: '我们鼓励每个人做真实的自己，不伪装、不迎合。只有真实面对自己，才能开始真正的探索。',
      icon: 'ri-shield-check-line',
    },
    {
      title: '深度',
      description: '我们不满足于表面的答案。每一次探索都力求触及问题的本质，提供有深度的洞见。',
      icon: 'ri-search-line',
    },
    {
      title: '尊重',
      description: '每个人的欲望和探索之路都是独一无二的。我们无条件尊重每个人的选择和节奏。',
      icon: 'ri-hand-heart-line',
    },
    {
      title: '安全',
      description: '我们致力于创造一个安全的空间，让每个人都能在这里安心地探索自己的内心世界。',
      icon: 'ri-lock-line',
    },
  ],
  team: [
    { name: '林墨', role: '创始人 & 主笔', description: '心理学研究者，深度探索人类欲望本质超过十年。' },
    { name: '苏晚', role: '联合创始人 & 情感顾问', description: '情感关系专家，帮助上千人改善亲密关系质量。' },
    { name: '陈望', role: '内容总监', description: '哲学背景出身，擅长将深刻的思想转化为易于理解的文字。' },
    { name: '江月', role: '身心导师', description: '冥想与身心修行实践者，致力于东方智慧与现代生活的融合。' },
  ],
  testimonials: [
    {
      name: '小鹿',
      location: '上海',
      text: '在欲望之岛，我第一次可以坦诚地面对自己。那些我以为"不该有"的渴望，原来只是我内在力量的另一种表达。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20woman%20with%20warm%20lighting%2C%20soft%20expression%2C%20minimalist%20studio%20background%2C%20artistic%20portrait%20photography&width=120&height=120&seq=avatar-01&orientation=squarish',
    },
    {
      name: '大树',
      location: '北京',
      text: '以前总觉得自己不够好，看完欲望之岛的文章才明白，那些"不够好"的感觉，其实是内心渴望成长的信号。现在我能把它们当作动力了。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20man%20with%20warm%20lighting%2C%20confident%20expression%2C%20minimalist%20studio%20background%2C%20artistic%20portrait%20photography&width=120&height=120&seq=avatar-02&orientation=squarish',
    },
    {
      name: 'Mia',
      location: '深圳',
      text: '参加了一次欲望之岛的线下工作坊，完全改变了我对"欲望"这个词的看法。原来它不是什么洪水猛兽，而是我的一部分。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20woman%20with%20warm%20lighting%2C%20thoughtful%20expression%2C%20minimalist%20studio%20background%2C%20artistic%20portrait%20photography&width=120&height=120&seq=avatar-03&orientation=squarish',
    },
  ],
  contact: {
    email: 'hello@yuwangzhidao.com',
    wechat: 'yuwangzhidao',
    address: '北京市朝阳区望京SOHO T3',
    hours: '周一至周五 10:00 - 18:00',
  },
};